interface EditabilityFields {
    id?: number | null;
    isScheduled?: boolean;
    isTemplate?: boolean;
}

/** A task's completion questions are only editable before it is saved, or on a template/scheduled task. */
export function canEditCompletionQuestions(task: EditabilityFields): boolean {
    return !!(task.isScheduled || task.isTemplate || !task.id);
}
